import { useState } from 'react';
import Modal from '../shared/Modal';
import Button from '../shared/Button';
import useTripStore from '../../context/TripStore';

const TimeBlockEditor = ({ place, isOpen, onClose }) => {
  const { updatePlace } = useTripStore();
  const [time, setTime] = useState(place?.lockedTime || '');

  const handleSave = () => {
    if (time) {
      updatePlace(place.id, { lockedTime: time });
    } else {
      updatePlace(place.id, { lockedTime: null });
    }
    onClose();
  };

  const handleRemove = () => {
    updatePlace(place.id, { lockedTime: null });
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title={`Lock Time: ${place?.name}`}>
      <div className="space-y-4">
        <div>
          <label htmlFor="time" className="block text-xs font-light text-gray-600 mb-1.5 uppercase tracking-wide">
            Locked Time
          </label>
          <input
            id="time"
            type="time"
            value={time}
            onChange={(e) => setTime(e.target.value)}
            className="w-full px-3 py-2 text-sm font-light border border-gray-300 focus:outline-none focus:border-black"
          />
          <p className="mt-2 text-xs font-light text-gray-400">
            Lock this place to a specific time (e.g., lunch reservation, museum entry time)
          </p>
        </div>

        <div className="flex gap-2 justify-end">
          {place?.lockedTime && (
            <Button variant="danger" onClick={handleRemove}>
              Remove Lock
            </Button>
          )}
          <Button onClick={handleSave}>Save</Button>
        </div>
      </div>
    </Modal>
  );
};

export default TimeBlockEditor;

